import { 
    printStickers, 
    printStickersRol, 
    printStickersRolEliot, 
    printStickersRolNalsani,
    printStickersRolReymon,
    updatePrinter 
} from '../../_services/print.service';

export const printStickersEvent = async (body) => {
    let res = await printStickers(body);
    if(! res.ok){
        throw new Error(res.error);
    }     
    return res.data.result;
}

export const printStickersRolEvent = async (body) => {
    let res = await printStickersRol(body);
    if(! res.ok){
        throw new Error(res.error);
    }     
    return res.data.result;
}

export const printStickersRolNalsaniEvent = async (body) => {
    let res = await printStickersRolNalsani(body);
    if(! res.ok){
        throw new Error(res.error);
    }     
    return res.data.result;
}

export const printStickersRolReymonEvent = async (body) => {
    let res = await printStickersRolReymon(body);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res.data.result;
}

export const printStickersRolEliotEvent = async (body) => {
    let res = await printStickersRolEliot(body);
    if(! res.ok){
        throw new Error(res.error);
    }     
    return res.data.result;
}

export const updatePrinterEvent = async (body) => {
    if(body.id === null || body.id === '') throw new Error('id vacío');
    if(body.ip === null || body.ip === '') throw new Error('ip vacía');
    let res = await updatePrinter(body);
    if(! res.ok){
        throw new Error(res.error);
    }     
    return res.data.result;
}